<template>
  <div>
    <v-row>
      <v-col cols="12" mt-3>
        <h3>Compétences: Approche du monde professionnel</h3>
      </v-col>
      <v-col cols="12" md="6" v-for="field in workFields" :key="field">
        <v-select
          :readonly="readonly"
          :label="descriptions[field]"
          :items="competencies_work"
          v-model="attestation[field]"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Description from "@/models/Description"

export default {
  props: {
    attestation: {
      required: true,
    },
    readonly: {
      required: false,
      default: false,
    }
  },
  data() {
    return {
      competencies_work: ["pas pertinent", "acquis", "partiellement acquis", "non acquis"],
      workFields: [
        'information_domain',
        'have_formation_project',
        'self_awareness',
        'mini_plan',
        'know_swiss_formation',
        'asked_for_internship',
        'have_dossier_paper',
        'have_dossier_digital',
        'post_apprentissage',
        'job_search_offers',
        'job_modify_dossier',
        'job_interview_participation'
      ]
    }
  },
  computed: {
    descriptions() {
      return Description.every()
    },
  }
}
</script>
